// Ficha da TaMoAki no Google (Perfil da Empresa), 19/10/2026.
// A ficha foi criada a 16/10 mas só fica pública depois de o Google a verificar.
// Enquanto os links estiverem vazios, nada aparece no site. Quando a ficha for
// verificada, basta preencher:
//   perfil  — o link público da ficha (Google Maps / Pesquisa)
//   avaliar — o link "Pedir avaliações" do Perfil da Empresa (g.page/r/…/review)
export const FICHA_GOOGLE = {
  perfil: '',
  avaliar: '',
};

/** Só links do Google (https). Um valor vazio ou de outro domínio desliga o bloco. */
export function linkFichaGoogle(url: string): string | null {
  try {
    const u = new URL(url);
    const google = /(^|\.)google\.[a-z.]+$|^g\.page$|^maps\.app\.goo\.gl$/.test(u.hostname);
    return u.protocol === 'https:' && google ? u.toString() : null;
  } catch {
    return null;
  }
}
